import {
  CALENDAR_ENTRY_STATUS_CREATE,
  CALENDAR_ENTRY_STATUS_CREATE_FAILURE,
  CALENDAR_ENTRY_STATUS_UPDATE,
  CALENDAR_ENTRY_STATUS_UPDATE_FAILURE,
  CALENDAR_ENTRY_STATUS_DELETE,
  CALENDAR_ENTRY_STATUS_DELETE_SUBMIT,
  CALENDAR_ENTRY_STATUS_DELETE_FAILURE
} from '../constants'

export const calendarEntryStatusCreate = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_CREATE })
export const calendarEntryStatusCreateFailure = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_CREATE_FAILURE })

export const calendarEntryStatusUpdate = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_UPDATE })
export const calendarEntryStatusUpdateFailure = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_UPDATE_FAILURE })

export const calendarEntryStatusDelete = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_DELETE })
export const calendarEntryStatusDeleteSubmit = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_DELETE_SUBMIT })
export const calendarEntryStatusDeleteFailure = payload => ({ payload, type: CALENDAR_ENTRY_STATUS_DELETE_FAILURE })
